var defaultStyles = {
  "root": "Base-Avatar",
  "circle": "Base-Avatar--Circle",
  "square": "Base-Avatar--Square",
  "text": "Base-Avatar--Text",
  "image": "Base-Avatar--Image",
  "xs": "Base-Avatar--Xs",
  "sm": "Base-Avatar--Sm",
  "md": "Base-Avatar--Md",
  "lg": "Base-Avatar--Lg",
  "xl": "Base-Avatar--Xl",
  "group": "Base-Avatar--Group",
  "max_count": "Base-Avatar--MaxCount"
};

export { defaultStyles as default };
